import { olympusService as e } from "../services/olympus/olympus.service.js";
import { useCurrentSpaceStore as t } from "../stores/current-space-store/useCurrentSpaceStore.js";
import { useEffect as n } from "react";
//#region src/lib/hooks/useHandleCurrentUserPermissionsChange.ts
var r = (r) => {
	let i = t((e) => e.updateSpaceRoles);
	n(() => {
		let t = (t) => {
			let n = e.client.users.getUserId();
			t.userId === n && (i(t.userId, t.userRoles), r && r(t.userRoles));
		};
		return e.client.internalEvents.on("user-permissions-change", t), () => {
			e.client.internalEvents.off("user-permissions-change", t);
		};
	}, [
		t((e) => e.space),
		r,
		i
	]);
};
//#endregion
export { r as useHandleCurrentUserPermissionsChange };
